import {combineReducers} from 'redux';
import {persistReducer} from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import {connectRouter} from 'connected-react-router';
import {getPersistConfig} from 'redux-deep-persist';
import {authReducer as auth} from '../modules/Auth/reducers/authReducer';
import {userReducer as user} from '../modules/Auth/reducers/userReducer';
import {
  options,
  shumaProperties,
  step11FileList,
  step9Filters,
  step9Firm,
  step9FirmForExcel,
  step9LittlePopup,
  step9SavedColumns,
  step9Shared,
  step9SharedForExcel,
  step9TaxAuthority, step9TaxAuthorityForExcel,
  stepData,
  stepStatus,
  tabSimilarPropertiesOptions,
} from '../modules/Inspection';
import {inspectionsList} from '../modules/InspectedList';
import {inspectionsByFirmList} from '../modules/InspectedFirm';
import {inspectedDatabase} from '../modules/InspectedDatabase';
import {tasks} from '../modules/Tasks';
import {globalErrorMessage, sendContactEmail, uploadingFilePopUp} from '../common';
import {decisionTreeOptionsReducer} from '../common/components/DecisionTreeOptions/reducers/decisionTreeOptionsReducer';
import {
  dataTableWithFiltersOptionsReducer
} from '../common/components/DataTableWithFilters/reducers/DataTableWithFiltersOptionsReducer';
import {firmUsersReducer} from "../common/reducers/firmUsersReducer";
import {generalNoteStatusTypesReducer} from "../common/reducers/generalNoteStatusTypesReducer";

const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    globalErrorMessage,
    auth,
    user,
    shumaProperties,
    stepStatus,
    stepData,
    inspectionsList,
    inspectionsByFirmList,
    step9TaxAuthority,
    step9TaxAuthorityForExcel,
    step9Firm,
    step9FirmForExcel,
    step9Shared,
    step9SharedForExcel,
    step9SavedColumns,
    step9LittlePopup,
    step9Filters,
    step11FileList,
    options,
    tabSimilarPropertiesOptions,
    uploadingFilePopUp,
    sendContactEmail,
    inspectedDatabase,
    tasks,
    decisionTreeOptionsReducer,
    dataTableWithFiltersOptionsReducer,
    firmUsersReducer,
    generalNoteStatusTypesReducer
  });

const persistConfig = history => getPersistConfig({
  key: 'accuraiser-client-root',
  storage,
  whitelist: [
    'auth.accessToken',
    'auth.expire',
    'auth.refreshToken',
    'user.user.username',
    'user.user.attributes',
    'user.userId',
    'user.userTypeID',
    'user.firmLogo',
    'user.allowInspectionsShare',
    'user.adminPermissionsLevel',
    'user.firmInspectionsAccess',
  ],
  rootReducer: rootReducer(history)
});

const persistedReducer = history => persistReducer(persistConfig(history), rootReducer(history));

export default persistedReducer;
